module.exports = __webpack_public_path__ + "img/500-bg-right.7f5a4e7.png";